import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COMMON_TOGGLE_DEBUG_MODE_BEGIN,
  COMMON_TOGGLE_DEBUG_MODE_SUCCESS,
  COMMON_TOGGLE_DEBUG_MODE_FAILURE,
  COMMON_TOGGLE_DEBUG_MODE_DISMISS_ERROR,
} from './constants';

export function toggleDebugMode(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COMMON_TOGGLE_DEBUG_MODE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/debug`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COMMON_TOGGLE_DEBUG_MODE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COMMON_TOGGLE_DEBUG_MODE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissToggleDebugModeError() {
  return {
    type: COMMON_TOGGLE_DEBUG_MODE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_TOGGLE_DEBUG_MODE_BEGIN:
      return {
        ...state,
        toggleDebugModePending: true,
        toggleDebugModeError: null,
      };

    case COMMON_TOGGLE_DEBUG_MODE_SUCCESS:
      return {
        ...state,
        toggleDebugModePending: false,
        toggleDebugModeError: null,
        projectDetail: action.data,
      };

    case COMMON_TOGGLE_DEBUG_MODE_FAILURE:
      return {
        ...state,
        toggleDebugModePending: false,
        toggleDebugModeError: action.data.error,
      };

    case COMMON_TOGGLE_DEBUG_MODE_DISMISS_ERROR:
      return {
        ...state,
        toggleDebugModeError: null,
      };

    default:
      return state;
  }
}
